/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Message Controls

/**
 * NGC Message Module
 */
@NgModule({
    exports: [

    ]
})
export class NgcMessageModule {
}